module.exports = __webpack_public_path__ + "img/share.aa392161.svg";